export const LEAD_TEMPERATURES = [
  { value: "hot", label: "Hot", color: "bg-red-100 text-red-700 border-red-200", dot: "bg-red-500" },
  { value: "warm", label: "Warm", color: "bg-amber-100 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  { value: "cold", label: "Cold", color: "bg-sky-100 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  { value: "nurture", label: "Nurture", color: "bg-violet-100 text-violet-700 border-violet-200", dot: "bg-violet-500" },
  { value: "unqualified", label: "Unqualified", color: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
];

export const CONTACT_TYPES = [
  "buyer", "seller", "buyer_seller", "investor", "landlord", "tenant", "fsbo",
  "expired", "referral", "past_client", "prospect",
  "contractor", "vendor", "inspector", "lender", "title_escrow", "attorney", "property_manager",
  "insurance_agent", "photographer", "agent", "other",
];

export const PROFESSIONAL_TYPES = ["contractor", "vendor", "inspector", "lender", "title_escrow", "attorney", "property_manager", "insurance_agent", "photographer", "agent"];
export const CLIENT_TYPES = CONTACT_TYPES.filter((t) => !PROFESSIONAL_TYPES.includes(t));
export const isProfessional = (c) => PROFESSIONAL_TYPES.includes(c?.contact_type);

export const LEAD_STATUSES = ["New", "Working", "Nurturing", "Qualified", "Converted", "Lost"];

export const PROPERTY_TYPES = [
  "single_family", "condo", "townhouse", "multi_family", "land", "commercial", "mobile", "new_construction",
];

export const PROPERTY_STATUSES = ["active", "for_sale", "fsbo", "preforeclosure", "foreclosure", "bankruptcy", "pending", "under_contract", "sold", "expired", "withdrawn", "off_market"];

export const PIPELINE_STAGES = [
  "New Lead", "Contacted", "Qualified", "Consultation", "Property Search",
  "Listing Preparation", "Showing", "Offer", "Negotiation", "Under Contract", "Closing", "Closed", "Lost",
];

export const TASK_PRIORITIES = ["low", "medium", "high", "urgent"];
export const TASK_TYPES = ["Call", "Text", "Email", "Meeting", "Send Property", "Send Documents", "Check Financing", "Ask for Referral", "Other"];

export const RELATIONSHIP_TYPES = [
  "owner", "co_owner", "seller", "potential_seller", "buyer", "potential_buyer", "interested_buyer", "investor",
  "tenant", "landlord", "listing_agent", "buyer_agent", "lender", "property_manager", "contractor",
  "past_owner", "former_owner", "agent", "referral", "neighbor", "other",
];

export const VERIFICATION_STATUSES = [
  { value: "seller_explicitly_identified", label: "Seller explicitly identified" },
  { value: "public_seller_contact", label: "Public seller contact" },
  { value: "attribution_contact", label: "Attribution contact" },
  { value: "agent_broker_contact", label: "Agent/broker contact" },
  { value: "unknown", label: "Unknown" },
  { value: "not_verified", label: "Not verified" },
];

export const DOC_CATEGORIES = ["Contracts", "Disclosures", "Inspection", "Appraisal", "Financing", "Identification", "Listing documents", "Photos", "Correspondence", "Other"];

export function tempMeta(value) {
  return LEAD_TEMPERATURES.find((t) => t.value === value) || LEAD_TEMPERATURES[4];
}

export function fullName(c) {
  return `${c?.first_name || ""} ${c?.last_name || ""}`.trim() || "Unnamed Contact";
}

export function money(v) {
  const n = Number(v || 0);
  if (!n) return "$0";
  return "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function initials(c) {
  return `${(c?.first_name || "")[0] || ""}${(c?.last_name || "")[0] || ""}`.toUpperCase() || "?";
}

export function titleCase(s) {
  return (s || "").replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

export function fmtStamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }).replace(/,(?=[^,]*$)/, "");
}

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (Number.isNaN(diff)) return "";
  if (diff < 45) return "just now";
  const units = [["y", 31536000], ["mo", 2592000], ["w", 604800], ["d", 86400], ["h", 3600], ["m", 60]];
  for (const [label, secs] of units) {
    if (diff >= secs) return `${Math.floor(diff / secs)}${label} ago`;
  }
  return "just now";
}

export function isAdminRole(role) {
  return role === "admin" || role === "master";
}

export const STAGE_COLORS = {
  "New Lead": "#3B82F6", Contacted: "#0EA5E9", Qualified: "#8B5CF6", Consultation: "#6366F1",
  "Property Search": "#D97706", "Listing Preparation": "#F59E0B", Showing: "#EC4899",
  Offer: "#EF4444", Negotiation: "#F97316", "Under Contract": "#6366F1", Closing: "#10B981",
  Closed: "#059669", Lost: "#94A3B8",
};
